import { render, staticRenderFns } from "./TooltipPocos.vue?vue&type=template&id=4bb2fb92&scoped=true"
import script from "./TooltipPocos.vue?vue&type=script&lang=js"
export * from "./TooltipPocos.vue?vue&type=script&lang=js"
import style0 from "./TooltipPocos.vue?vue&type=style&index=0&id=4bb2fb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2fb92",
  null
  
)

export default component.exports